callpy_global.CMessage = function()
{
    this.module_name = "Message ";
    this.module_log_rang = 100;

    var _this = this;
    this.templates = {};

    this.init_templates = function ()
    {
        _this.templates["user_data"] = ["site", "browser", "type","key","from_ls","referer","hidden","webRTCsupp","origin","width","channel", "title", "enter", "fromref", "visits", "lang"];
        _this.templates["get_scripts_mng"] = ["site", "browser", "type", "webRTCsupp"];
        _this.templates["get_site_info"] = ["site_id"];
        _this.templates["get_lan_info"] = ["login"];
        _this.templates["add_phrase"] = ["key", "phrase", "color"];
        _this.templates["delete_phrase"] = ["key", "id"];


        _this.templates["lan_register"] = ["site_id", "login", "tariff", "info"];
        _this.templates["update_site_settings"] = ["name", "value", "site_id"];
        _this.templates["change_tariff"] = ["key", "tariff"];

        _this.templates["delete_manager"] = ["key"];
        //_this.templates["change_manager"] = ["user", "manager", "site", "domain", "activityLevel"];
        _this.templates["change_manager"] = ["user", "manager", "site", "domain", "statusData"];

        _this.templates["set_client_type"] = ["type"];
        //_this.templates["set_php_server"] = ["php_server"];
        _this.templates["set_fms_server"] = ["fms_server"];
        _this.templates["set_fms_app"] = ["fms_app"];
        _this.templates["set_key"] = ["key"];
        _this.templates["set_site"] = ["site"];
        _this.templates["set_site_id"] = ["site_id"];
        _this.templates["set_peer"] = ["key", "type", "rtmfp_key"];
        //_this.templates["set_display_size"] = ["width", "height"];
        _this.templates["set_message_history"] = ["history"];
        _this.templates["set_origin"] = ["origin", "cookies", "webRTCsupp"];

        _this.templates["clear_peer"] = [];
        _this.templates["connect_to_fms"] = [];
        _this.templates["disconnect_from_fms"] = [];

        _this.templates["ping"] = ["pingtype"]; //система пинга пира type = request | answer

        _this.templates["send_message"] = ["message", "managerName", "channel", "messageType", "messagesIds", "attached_site_id", "attached_dialog_id"];
        _this.templates["edit_message"] = ["message", "messageId", "managerName", "channel", "jsTime"];

        _this.templates["send_message_dialog"] = ["text", "dialog_id", "part_id", "part_site_id", "clientType", "messageType", "name", "messagesIds", "attached_site_id"];
        //_this.templates["send_automessage"] = ["message", "managerName", "userId"];
        _this.templates["automessage"] = ["message", "time"];
        _this.templates["holdingmessage"] = ["message", "managerId"];
        _this.templates["message_received"] = ["messageId"];

        _this.templates["update_call_set"] = ["audio", "video"];
        _this.templates["start_call"] = [];

        _this.templates["chat_call"] = ["webRTC", "peerRTCType", "video"];
        _this.templates["chat_answ"] = ["peerRTCType"];
        _this.templates["end_call"] = [];
        _this.templates["end_dialup"] = [];
        //_this.templates["end_call_accepted"] = [];
        _this.templates["call_state"] = ["state"];
        _this.templates["dialog_call_state"] = ["dialog_id", "state"];
        _this.templates["call_createOffer"] = [];
        _this.templates["call_in_queue"] = [];
        _this.templates["update_stats"] = ["stat"];

        _this.templates["get_user_page"] = [];
        //_this.templates["get_display_size"] = [];
        _this.templates["get_scroll"] = [];
        _this.templates["get_scroll_cw"] = []; //кроме скролла получает размеры окна и куки
        _this.templates["go_url"] = ["url", "origin", "width", "height", "scroll", "elements"];
        _this.templates["set_elements"] = ["elements"]; //передача менеджеру отрисованных на странице элементов (если есть)
        _this.templates["select_new_user"] = ["site", "oldSite", "siteId", "oldSiteId", "managerId", "oldId", "newId", "withHistory", "offSelect"];
        _this.templates["select_new_user_list"] = ["listType", "userId", "siteId", "data"];
        //_this.templates["click"] = ["x", "y"];
        _this.templates["click"] = ["x", "y", "tag", "id", "onclick", "outerHtml", "elementX", "elementY", "parentTag", "parentId", "parentOnclick", "parentOuterHtml", "parentElementX", "parentElementY", "url"];
        _this.templates["mouse_position"] = ["coords"];
        _this.templates["visual_message"] = ["circle", "tooltip", "message", "element_id", "url"];
        _this.templates["delete_visual_message"] = ["element_id"];
        _this.templates["remote_control_request"] = [];
        _this.templates["remote_control_request_cancel"] = [];
        _this.templates["remote_control_answer"] = ["request"];
        _this.templates["remote_observe_request"] = [];
        _this.templates["remote_observe_request_cancel"] = [];
        _this.templates["remote_observe_answer"] = ["request"];
        _this.templates["get_cookies"] = [];
        _this.templates["get_data"] = ["type"];
        _this.templates["set_cookies"] = ["cookies"];
        _this.templates["input_field"] = ["input", "value", "url"]; //передача значений полей input
        _this.templates["textarea_field"] = ["input", "value", "url"]; //передача значений полей textarea
        _this.templates["select_field"] = ["select", "values", "selected", "url"]; //значения полей select
        _this.templates["keydown"] = ["keys", "site_id", "site", "key"]; //передача информации о нажатой кнопке
        _this.templates["writing_text"] = []; //сообщение клиенту о том, что консультант набирает текст
        _this.templates["notification"] = ["ntype"]; //если нужно передать нотификацию
        _this.templates["send_typing_speed"] = ["speed", "count"]; //передача данных о скорости набора текста

        _this.templates["select_new_dialog"] = ["dialog_id", "site_id", "part_id", "part_site_id", "participants", "history"]; //выбор группового диалога

        _this.templates["select_area"] = ["x1", "y1", "x2", "y2", "element_id", "url"]; //x1,y1 - левый верхний угол; x2,y2 - правый нижний. Url - страницы, на которых необходимо обработать сообщение (в случае,
                                                                                        //если ни одна вкладка у клиента не активна)
        _this.templates["delete_select_area"] = ["element_id"];
        _this.templates["unselect_area"] = ["close"];
        _this.templates["mouse_up"] = ["element", "mousesx", "mousesy", "mousecx", "mousecy"];
        _this.templates["scroll"] = ["height", "url", "width"];
        _this.templates["scroll_cw"] = ["height", "cookie", "inputs"];
        _this.templates["window_resize"] = ["width", "height"];
        _this.templates["tab_visibility"] = ["isVisible"];

        _this.templates["icecandidate"] = ["label", "id", "candidate"];
        _this.templates["description"] = ["descriptor", "video"];
        _this.templates["changeCallState"] = ["video"];

        _this.templates["update_activity"] = ["id", "level", "site_id"];
        _this.templates["screen_share"] = ["status"];

        _this.templates["disconnect_request"] = ["site_url", "site_id", "key", "type", "referer", "hidden", "webRTCsupp", "origin", "chatWindowStatus", "manager", "browser", "width", "enter", "title", "visits"];
    };

    this.create_message = function(action, data)
    {
        if (_this.templates[action])
        {
            var result = {"action" : action};
            for (var val in data)
            {
                if (!data.hasOwnProperty(val)) continue;
                if (_this.templates[action][val] !== undefined){
                    result[val] = data[val];
                }else{
                    m_callpy.m_logger.warn("Передача несуществующего аргумента %s для действия %s", val, action);
                }
                result[val] = data[val];
            }
            for (var i=0; i<_this.templates[action].length; i++){
                if (data[_this.templates[action][i]] === undefined){
                    m_callpy.m_logger.info("Не указан аргумент %s для действия %s", _this.templates[action][i], action);
                }
            }

            return result;
        }
        else
        {
            m_callpy.m_logger.error("Не задан обязательный аргумент action для метода create_message или такого действия не сущесвтует");
            return false;
        }
    };
};